import React from 'react'
import styled from 'styled-components'
import { Icon } from '@iconify/react';
import timesSolid from '@iconify/icons-la/times-solid';
import moment from 'moment-timezone'
import { colour_lookup, connectivity_colour_lookup } from '../../common/Colours'
import { getHost } from '../../../api/host'
import { cloneDeep } from 'lodash';
import connectionIcon from '@iconify/icons-icomoon-free/connection';
import disconnectedSolid from '@iconify/icons-clarity/disconnected-solid';
import batteryHalf from '@iconify/icons-bi/battery-half';
import lightningFill from '@iconify/icons-bi/lightning-fill';

export const StatusContainer = styled.div`
  max-height: 100%;
  width: 380px;
  background: transparent;
  position: absolute;
  top: 0;
  right: 0;
  overflow-y: scroll;
  display: block;
`;

const StyledSiteStatusBox = styled.div`
  display: block;
  width: 350px;
  background: #FFF;
  margin: 10px auto;
  position: relative;
  overflow: auto;
  padding: 10px 20px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
`;

const Close = styled.div`
  position: absolute;
  top: 12px;
  right: 10px;
  padding: 5px;
  cursor: pointer;
  color: #555;
  
  &:hover {
    color: #333;
  }
`;

const StatusTitle = styled.div`
  display: block;
  position: relative;
  margin: 10px 30px 25px 10px;
  color: #333;
  font-size: 20px;
`;

const StatusLabel = styled.div`
  margin: 10px;
  color: #444;
  font-size: 16px;
`;

const StatusPositionBlock = styled.div`
  margin: 10px;
  color: #444;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
`;

const PositionName = styled.div`
  line-height: 25px;
`;

const PositionIcons = styled.div`
`;

export const SiteStatusBox = ({ site, onClose, settings }: { site: any, onClose: any, settings: any }) => {
  
  if (typeof site === 'undefined') {
    return null;
  }
  
  // Get the number of features to be displayed so the SVG width can be tailored
  let settings_feature_count = Object.values(settings.features).filter((value, key) => value).length;
  
  return (
    <StyledSiteStatusBox>
      <Close onClick={() => { onClose(site) }}><Icon width='25px' height='25px' icon={timesSolid} /></Close>
      <StatusTitle>{site.title}</StatusTitle>
      {site.positions.map((position, index) => (
        <StatusPositionBlock key={index}>
          <PositionName>
            {position.title}
          </PositionName>
          <PositionIcons>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox={`0 0 ${40 * settings_feature_count} 30`} height='25px'>

              {settings.features.connectivity &&
              <g transform='translate(0,0)'>
                <circle cx='15' cy='15' r='15' fill='#fff'/>
                <g transform='translate(2.5,2.5)'>                  
                  <Icon color={connectivity_colour_lookup(position.status.online_status)} width='25px' height='25px' icon={position.status.online_status === 'offline' || position.status.online_status === 'not_measuring'? disconnectedSolid : connectionIcon}/>
                </g>
              </g>}

              {settings.features.exceedances &&
              <g transform='translate(40,0)'>
                <circle cx='15' cy='15' r='15' fill='#fff'/>
                <circle transform='translate(1, 1)' cx='14' cy='14' r='14' fill={colour_lookup(position.status.exceedance_level_total || 'green')}/>
                <circle transform='translate(5, 5)' cx='10' cy='10' r='10' fill={colour_lookup(position.status.exceedance_level_now || 'green')}/>
              </g>}

              {settings.features.battery &&
              <g transform='translate(80,0)'>
                <circle cx='15' cy='15' r='15' fill='#fff'/>
                <circle transform='translate(1, 1)' cx='14' cy='14' r='14' fill={colour_lookup(position.status.charge_status)}/>
                <circle transform='translate(5, 5)' cx='10' cy='10' r='10' fill='#FFF'/>
                <g transform='translate(7.5,7.5)'>
                  <Icon color={colour_lookup(position.status.charge_status)} width='15px' height='15px' icon={lightningFill}/>
                </g>
              </g>}

              {settings.features.tunnel &&
              <g transform='translate(120,0)'>
                <circle cx='15' cy='15' r='15' fill='#fff'/>
                <g transform='translate(5,5)'>
                  <Icon color={colour_lookup('grey')} width='20px' height='20px' icon={batteryHalf}/>
                </g>
              </g>}

            </svg>
          </PositionIcons>
        </StatusPositionBlock>
      ))}
    </StyledSiteStatusBox>
  )
}